module.exports = __webpack_public_path__ + "img/camera-border.1028bcbd.svg";